export class AppBase {
  public static href = window.location.origin;
}
